import { useEffect, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useQuery, useMutation } from "@tanstack/react-query";
import moment from "jalali-moment";
import { useDispatch, useSelector } from "react-redux";
import { FiCheck } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import { addErrorMessage, addSuccessMessage, setPageTitle } from "../slice";
import { MATCH_API } from "../api";
import { useCurrentState } from "../hooks";
import BaseSwiper from "../components/home/BaseSwiper";
import ConfirmModal from "../components/ConfirmModal";
import logoImage from "../assets/logo/Frame.svg";
import { ReactComponent as Test } from "../assets/logo/Frame.svg";

function Home() {
  const dispatch = useDispatch();
  const updateUserStatus = useCurrentState();
  const { data } = useSelector((state) => state.UserCurrentState);
  const [meetingResult, setMeetingResult] = useState();
  const [message, setMessage] = useState("");
  const [action, setAction] = useState("");

  const { mutate: addResultMeeting } = useMutation((body) => MATCH_API.AddResultMeeting(body), {
    onSuccess: ({ data: { message } }) => {
      updateUserStatus();
      dispatch(addSuccessMessage(message));
    },
    onError: ({ response }) => {
      dispatch(addErrorMessage(response));
    },
  });

  const { mutate: acceptMatchAndContinue } = useMutation(
    (data) => MATCH_API.AcceptMatchAndContinue(data),
    {
      onSuccess: ({ data: { message } }) => {
        updateUserStatus();
        setAction("");
        dispatch(addSuccessMessage(message));
      },
      onError: ({ response }) => {
        setAction("");
        dispatch(addErrorMessage(response));
      },
    }
  );

  const { mutate: rejectMatchAndSearchAgain } = useMutation(
    (information) =>
      MATCH_API.RejectMatchAndSearchAgain(information.body, information.isSearchByBranch),
    {
      onSuccess: ({ data: { message } }) => {
        setAction("");
        updateUserStatus();
        dispatch(addSuccessMessage(message));
      },
      onError: ({ response }) => {
        setAction("");
        dispatch(addErrorMessage(response));
      },
    }
  );

  const { mutate: RegisterMarriage } = useMutation((body) => MATCH_API.RegisterMarriage(body), {
    onSuccess: ({ data: { message } }) => {
      setAction("");
      updateUserStatus();
      dispatch(addSuccessMessage(message));
    },
    onError: ({ response }) => {
      setAction("");
      dispatch(addErrorMessage(response));
    },
  });

  const handleMeetingMessage = (type) => {
    let body;
    if (type === "add") {
      body = {
        body: message,
        createdTime: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSS Z"),
      };
    }
    if (type === "remove") {
      setMessage("");
      body = {
        body: "",
        createdTime: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss.SSS Z"),
      };
    }
    addResultMeeting(body);
  };

  const handleActionOnCandidate = (body) => {
    switch (action) {
      case "acceptMatchAndContinue":
        acceptMatchAndContinue({ body: undefined });
        break;
      case "rejectMatchAndSearchAgain":
        rejectMatchAndSearchAgain({ isSearchByBranch: false, body });
        break;
      case "rejectMatchAndSearchAgainByBranch":
        rejectMatchAndSearchAgain({ isSearchByBranch: true, body });
        break;
      case "RegisterMarriage":
        RegisterMarriage(body);
        break;
      default:
        break;
    }
  };

  useQuery(["getResultMeeting"], () => MATCH_API.GetResultMeeting(), {
    onSuccess: ({ data }) => {
      if (data.success) {
        setMeetingResult(data.data?.body);
        setMessage(data.data?.result);
      }
    },
    onError: () => {},
    enabled: parseInt(data.code) === 46 || parseInt(data.code) === 48,
  });

  useQuery(["GetResultMarriage"], () => MATCH_API.GetResultMarriage(), {
    onSuccess: ({ data }) => {
      setMeetingResult(data.data?.body);
      setMessage(data.data?.result);
    },
    enabled: parseInt(data.code) === 15,
  });

  useEffect(() => {
    dispatch(setPageTitle(""));
  }, [dispatch]);

  return (
    <Box width="100%" display="flex" flexDirection="column" alignItems="center">
      {parseInt(data.code) === 46 || parseInt(data.code) === 48 || parseInt(data.code) === 15 ? (
        <>
          <ConfirmModal
            message="آیا از انتخاب خود اطمینان دارید؟"
            open={action.length !== 0}
            onClose={() => setAction("")}
            onSubmit={handleActionOnCandidate}
            withDiscription={
              action === "rejectMatchAndSearchAgain" ||
              action === "rejectMatchAndSearchAgainByBranch"
            }
            withTimePicker={action === "RegisterMarriage"}
          />
          <Grid
            container
            display="flex"
            flexDirection="row-reverse"
            width="100%"
            sx={{
              backgroundColor: "#EEEEEE",
              boxSizing: "border-box",
              padding: { xs: "2rem 1rem 3.5rem 1rem", lg: "2rem 1rem" },
              borderRadius: "1.1rem",
              marginBottom: "1rem",
            }}
          >
            <Grid
              item
              xs={12}
              sm={4}
              md={3}
              lg={4}
              display="flex"
              justifyContent="center"
              alignItems="flex-start"
            >
              <Test width="90%" style={{ height: "auto", maxWidth: "400px" }} />
            </Grid>
            <Grid item xs={12} sm={8} md={9} lg={8}>
              <Box>
                <Typography
                  variant="h1"
                  color="#00BE93"
                  fontWeight={700}
                  fontSize="1.2rem"
                  mb="1.8rem"
                  sx={{ direction: "rtl" }}
                >
                  برامون از نتیجه بگو...
                </Typography>
                <Typography
                  variant="h2"
                  component="pre"
                  mb="2rem"
                  sx={{
                    direction: "rtl",
                    whiteSpace: "break-spaces",
                    textAlign: { xs: "justify", md: "justify" },
                  }}
                >
                  {meetingResult ? meetingResult : ""}
                </Typography>
                <Box
                  width="100%"
                  sx={{ position: "relative", height: { xs: "200px", md: "100px" } }}
                >
                  <textarea
                    placeholder="اینجا بنویسید..."
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                    style={{
                      boxSizing: "border-box",
                      width: "100%",
                      backgroundColor: "#FFFFFF",
                      border: "none",
                      borderRadius: "0.6rem",
                      padding: "0.7rem",
                      minHeight: "100%",
                      direction: "rtl",
                      resize: "none",
                      outline: "none",
                      color: "#4c466f",
                    }}
                  />
                  <Box
                    display="flex"
                    flexDirection="row-reverse"
                    sx={{ position: "absolute", top: "10px", left: "22px" }}
                  >
                    <Button
                      onClick={handleMeetingMessage.bind(this, "add")}
                      sx={{
                        minWidth: 0,
                        width: "35px",
                        heigth: "35px",
                        aspectRatio: "1/1",
                        backgroundColor: "#8BEBD5",
                        borderRadius: "0.7rem",
                        marginLeft: "0.5rem",
                      }}
                    >
                      <FiCheck fontSize="1.1rem" color="#4C466F" />
                    </Button>
                    <Button
                      onClick={handleMeetingMessage.bind(this, "remove")}
                      sx={{
                        minWidth: 0,
                        width: "35px",
                        heigth: "35px",
                        aspectRatio: "1/1",
                        backgroundColor: "#ECF2FF",
                        borderRadius: "0.7rem",
                      }}
                    >
                      <HiOutlineTrash fontSize="1.1rem" color="#4C466F" />
                    </Button>
                  </Box>
                </Box>
              </Box>
              <Grid
                item
                xs={12}
                display="flex"
                flexDirection="row-reverse"
                flexWrap="wrap"
                justifyContent={{ xs: "center", lg: "flex-start" }}
                mt={3}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={4}
                  xl={3}
                  display="flex"
                  justifyContent={{ xs: "center", sm: "90%", md: "flex-end" }}
                  my={{ xs: "0.4rem", md: "0" }}
                >
                  <Button
                    variant="s1"
                    sx={{
                      width: { xs: "100%", md: "auto" },
                    }}
                    onClick={() =>
                      setAction(
                        parseInt(data.code) === 15 ? "RegisterMarriage" : "acceptMatchAndContinue"
                      )
                    }
                  >
                    {parseInt(data.code) === 15 ? "ازدواج کردم" : "ادامه روند آشنایی"}
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={4}
                  xl={3}
                  display="flex"
                  justifyContent={{ xs: "center", md: "flex-end" }}
                  my={{ xs: "0.4rem", md: "0" }}
                >
                  <Button
                    variant="s1"
                    sx={{
                      width: { xs: "100%", sm: "90%", md: "auto" },
                    }}
                    onClick={() => setAction("rejectMatchAndSearchAgain")}
                  >
                    جستجو توسط خودم
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={4}
                  xl={3}
                  display="flex"
                  justifyContent={{ xs: "center", md: "flex-end" }}
                  my={{ xs: "0.4rem", lg: "0" }}
                >
                  <Button
                    variant="s1"
                    sx={{
                      width: { xs: "100%", sm: "90%", md: "auto" },
                    }}
                    onClick={() => setAction("rejectMatchAndSearchAgainByBranch")}
                  >
                    جستجو توسط مرکز
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid
            container
            display="flex"
            flexDirection="row-reverse"
            width="100%"
            sx={{
              backgroundColor: "#EEEEEE",
              boxSizing: "border-box",
              padding: "  1rem",
              borderRadius: "1.1rem",
              marginBottom: "1rem",
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={4}
              my={1}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                boxSizing: "border-box",
                padding: "0 0.5rem",
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                minHeight="100%"
                mb={{ xs: "1rem", sm: "1rem", md: 0, lg: 0 }}
                sx={{
                  backgroundColor: "#FFFFFF",
                  boxSizing: "border-box",
                  padding: "1rem",
                  borderRadius: "0.7rem",
                }}
              >
                <Typography variant="h2" mb="2rem" sx={{ direction: "rtl" }}>
                  خوشحالم از انتخابم... با همین مورد ادامه می‌دهم.
                </Typography>
                <Button variant="s1" onClick={() => setAction("acceptMatchAndContinue")}>
                  ادامه روند آشنایی
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={4}
              my={1}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                boxSizing: "border-box",
                padding: "0 0.5rem",
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                minHeight="100%"
                mb={{ xs: "1rem", sm: "1rem", md: 0, lg: 0 }}
                sx={{
                  backgroundColor: "#FFFFFF",
                  boxSizing: "border-box",
                  padding: "1rem",
                  borderRadius: "0.7rem",
                }}
              >
                <Typography variant="h2" mb="2rem" sx={{ direction: "rtl" }}>
                  می خوام بتونیم دوباره سرچ کنم و شرایط رو دوباره بررسی کنم...
                </Typography>
                <Button variant="s1" onClick={() => setAction("rejectMatchAndSearchAgain")}>
                  جستجو توسط خودم
                </Button>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={4}
              my={1}
              sx={{
                boxSizing: "border-box",
                padding: "0 0.5rem",
              }}
            >
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                minHeight="100%"
                sx={{
                  backgroundColor: "#FFFFFF",
                  boxSizing: "border-box",
                  padding: "1rem",
                  borderRadius: "0.7rem",
                }}
              >
                <Typography variant="h2" mb="2rem" sx={{ direction: "rtl" }}>
                  می خوام مرکز به جای من سرچ کنه و مورد جدید بهم معرفی کنه...
                </Typography>
                <Button variant="s1" onClick={() => setAction("rejectMatchAndSearchAgainByBranch")}>
                  جستجو توسط مرکز
                </Button>
              </Box>
            </Grid>
          </Grid> */}
        </>
      ) : (
        <img src={logoImage} alt="logo" style={{ maxWidth: "70vw" }} />
      )}
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-end"
        sx={{ width: { xs: "95%", md: "70%", mb: { xs: 1, md: 0 } } }}
      >
        <Typography variant="h1" textAlign="right" sx={{ mb: { xs: 2, sm: 2, md: 3, lg: 3 } }}>
          :هدا چگونه به شما کمک می کند
        </Typography>
        <Typography variant="h2" textAlign="justify" lineHeight={1.3}>
          جوانان مجرد متقاضی ازدواج را از ابتدای تصمیم‌گیری برای ازدواج تا 4 سال پس از ازدواج همراهی
          می‌کند، آموزش‌های لازم را به شکلی جذاب در اختیارشان قرار می‌دهد، ، آزمون‌های تخصصی همراه
          با تفسیر را برای کمک به شناخت بیشتر، به آنان ارائه می کند، امکان جستجو و انتخاب زوج مناسب
          را برایشان مهیا می‌کند و در تمامی این مراحل با بهره‌گیری از شبکه مشاوران متخصص به آنان
          مشاوره می‌دهد
        </Typography>
        {/* <Typography variant="h1" mt={5} mb={3}>
          :مطالب داغ
        </Typography> */}
      </Box>
      {/* <BaseSwiper /> */}
    </Box>
  );
}

export default Home;
